/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  GetApiV1Associatedcompany200,
  GetApiV1Associatedcompany400,
  GetApiV1Associatedcompany401,
  GetApiV1Associatedcompany500,
  GetApiV1AssociatedcompanyQueryParams,
  GetApiV1AssociatedcompanyQueryResponse,
} from "../../types/associatedCompanyController/GetApiV1Associatedcompany.ts";
import { associatedCompanyListItemViewModelPaginatedResponseSchema } from "../associatedCompanyListItemViewModelPaginatedResponseSchema.ts";

export const getApiV1AssociatedcompanyQueryParamsSchema = z.object({
  Cnpj: z.optional(z.string()),
  Name: z.optional(z.string()),
  Active: z.optional(z.boolean()),
  PoloId: z.optional(z.coerce.number().int()),
  SortBy: z.string().default("name"),
  SortDirection: z.string().default("asc"),
  PageNumber: z.coerce.number().int().default(1),
  PageSize: z.coerce.number().int().default(30),
}) as unknown as ToZod<GetApiV1AssociatedcompanyQueryParams>;

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const getApiV1Associatedcompany200Schema = z.lazy(
  () => associatedCompanyListItemViewModelPaginatedResponseSchema,
) as unknown as ToZod<GetApiV1Associatedcompany200>;

/**
 * @description (Bad Request) Requisição em formato incorreto ou com dados faltantes.
 */
export const getApiV1Associatedcompany400Schema =
  z.any() as unknown as ToZod<GetApiV1Associatedcompany400>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const getApiV1Associatedcompany401Schema =
  z.any() as unknown as ToZod<GetApiV1Associatedcompany401>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const getApiV1Associatedcompany500Schema =
  z.any() as unknown as ToZod<GetApiV1Associatedcompany500>;

export const getApiV1AssociatedcompanyQueryResponseSchema = z.lazy(
  () => getApiV1Associatedcompany200Schema,
) as unknown as ToZod<GetApiV1AssociatedcompanyQueryResponse>;
